import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigOptions, ConfigService } from '@wilson/config';

@Injectable({
  providedIn: 'root',
})
export class TalkjsGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  getLoggedInUserSignature() {
    return this.httpClient.get(`${this.config.host}/talkjs/signature`, {
      responseType: 'text',
    });
  }
}
